<template>
  <v-container fluid>
    <PageHeader :title="titleName" no-padding />
    <v-tabs v-model="currentTab" dark grow centered>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#approval-levels">
        Approval Levels
      </v-tab>
      <v-tab href="#data-grades">
        Data Grades
      </v-tab>
      <v-tab href="#data-qualifiers">
        Qualifiers
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <v-tab-item value="approval-levels">
        <v-layout wrap>
          <v-flex xs12 xl6 pa-2>
            <ContinuousApprovalLevelsDefaultManage :continuousDatabaseType="currentTenantContinuousDatabaseType" :loading="ContinuousDataConfigQueryOptionIsLoading" :readonly="!isSystemAdmin" />
          </v-flex>
          <v-flex xs12 xl6 pa-2>
            <ContinuousApprovalLevelsTenantManage :tenantName="tenantNameOrDefault" :tenantId="tenantIdOrDefault" />
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item value="data-grades">
        <ContinuousDataGradesManage :tenantName="tenantNameOrDefault" :tenantId="tenantIdOrDefault" />
      </v-tab-item>
      <v-tab-item value="data-qualifiers">
        <ContinuousDataQualifiersManage :tenantName="tenantNameOrDefault" :tenantId="tenantIdOrDefault" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
  import PageHeader from '@/components/generic/PageHeader'
  import ContinuousApprovalLevelsDefaultManage from '@/components/ContinuousDataOutputManage/ContinuousApprovalLevels/ContinuousApprovalLevelsDefaultManage'
  import ContinuousApprovalLevelsTenantManage from '@/components/ContinuousDataOutputManage/ContinuousApprovalLevels/ContinuousApprovalLevelsTenantManage'
  import ContinuousDataGradesManage from '@/components/ContinuousDataOutputManage/ContinuousDataGrades/ContinuousDataGradesManage'
  import ContinuousDataQualifiersManage from '@/components/ContinuousDataOutputManage/ContinuousDataQualfiers/ContinuousDataQualifiersManage'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const authenticate = createNamespacedHelpers('authenticate')
  const continuousdbconfig = createNamespacedHelpers('continuousdbconfig')
  export default {
    components: {
      PageHeader,
      ContinuousApprovalLevelsDefaultManage,
      ContinuousApprovalLevelsTenantManage,
      ContinuousDataGradesManage,
      ContinuousDataQualifiersManage,
    },
    props: {
      tenantName: {
        type: String,
        default: '',
      },
      tenantId: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        currentTab: 'approval-levels',
      }
    },
    computed: {
      ...authenticate.mapGetters(['currentUserGroup', 'isSystemAdmin']),
      ...continuousdbconfig.mapState(['ContinuousDataConfigQueryOption', 'ContinuousDataConfigQueryOptionIsLoading']),
      titleName() {
        return `${this.tenantName ? this.tenantName : this.currentUserGroup.name} Continuous Data Output Management`
      },
      tenantNameOrDefault() {
        return this.tenantName || this.currentUserGroup.name
      },
      tenantIdOrDefault() {
        return this.tenantId || this.currentUserGroup.id
      },
      currentTenantIsDifferentFromUserTenant() {
        return this.currentUserGroup.name != this.tenantName
      },
      currentTenantContinuousDatabaseType() {
        return this.ContinuousDataConfigQueryOption.ConfigurationValue || ''
      },
    },
    methods: {
      ...continuousdbconfig.mapMutations({ resetContinuousDbConfig: 'RESET' }),
      ...continuousdbconfig.mapActions(['getContinuousDataConfigQueryOption']),
    },
    async created() {
      await this.getContinuousDataConfigQueryOption(this.tenantIdOrDefault)
    },
    beforeDestroy() {
      if (this.currentTenantIsDifferentFromUserTenant) {
        this.resetContinuousDbConfig()
      }
    },
  }
</script>